import { render, staticRenderFns } from "./AuthorModal.vue?vue&type=template&id=40a4cc26"
import script from "./AuthorModal.vue?vue&type=script&lang=ts"
export * from "./AuthorModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports